import React from "react"
import Vista from "../../components/Vista"
import TableCustom from "../../components/TableCustom"
import dateComponent from "../../components/dateComponent"
import { useState } from "react"
import moment from "moment"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import pdfOrdenServicio from "../../pdfs/pdfOrdenServicio"
import servo from "../../services/servo"
import "../zonda-redesign.css"

const busquedaDefault = {
  status: "",
  fechaInicio: dateComponent.getFirstDayOfYear(),
  fechaFinal: dateComponent.getActualDay()
}

const OrdenServicio = () => {
  const [busqueda, setBusqueda] = useState({ ...busquedaDefault })

  let dataTable = {
    creado: {
      nombre: "Fecha",
      content: (e) => {
        return moment(e?.creado).format("L")
      }
    },
    empresa: {
      nombre: "Empresa",
      content: (e) => {
        return e?.empresas?.nombre
      }
    },
    status: {
      nombre: "Status",
      content: (e) => {
        return e?.status
      }
    },
    pdf: {
      nombre: "PDF",
      content: (item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%"
            }}
          >
            <PictureAsPdfIcon
              style={{ color: "#157CC1", cursor: "pointer" }}
              onClick={async () => {
                try {
                  const res = await servo.get(
                    "orden-servicios?idOrdenServicio=" +
                      item.idOrdenServicio +
                      "&expand=" +
                      "checklists," +
                      "empresas," +
                      "checklists.datoschecklists.areas," +
                      "checklists.datoschecklists.carros," +
                      "checklists.datoschecklists.empresas," +
                      "checklists.gasolinachecklists.notas," +
                      "observaciones," +
                      "manosObraOrdenServicio.manosObra," +
                      "refacciones.productos," +
                      "diagnosticos.productos.lote," +
                      "ordenesCompra.ordenesCompraRefacciones.productos," +
                      "ordenesCompra.ordenesCompraRefacciones.proveedores," +
                      "checklists.gasolinachecklists," +
                      "inspecciones," +
                      "creados"
                  )

                  const ordenCompleta = res?.cuerpo?.resultado?.[0]

                  if (!ordenCompleta) {
                    console.error("No se encontró la orden completa")
                    return
                  }

                  let pdf = await pdfOrdenServicio(ordenCompleta)
                  window.open(window.URL.createObjectURL(pdf), "_blank")
                } catch (error) {
                  console.error("Error al generar el PDF:", error)
                }
              }}
            />
          </div>
        )
      }
    }
  }

  let dataPdf = {
    creado: {
      nombre: "Fecha",
      content: (e) => {
        return moment(e?.creado).format("L")
      }
    },
    empresa: {
      nombre: "Empresa",
      content: (e) => {
        return e?.empresas?.nombre
      }
    },
    status: {
      nombre: "Status",
      content: (e) => {
        return e?.status
      }
    }
  }

  return (
    <Vista style={{ display: "block" }}>
      <main className="service-page">
        <div className="service-page__inner">
          <header className="service-page__header">
            <div>
              <p className="service-page__eyebrow">Administración de taller</p>
              <h1>Órdenes de servicio</h1>
              <p>Consulta, filtra y da seguimiento al mantenimiento de cada unidad.</p>
            </div>
            <span className="service-page__badge"><i className="service-page__badge-dot" /> Operación activa</span>
          </header>
          <section className="service-page__content" aria-label="Listado de órdenes de servicio">
            <TableCustom
        // filtroCustom={(d) => {
        //   if (d?.eliminado) {
        //     return false
        //   }
        //   if (busqueda.status && d?.status !== busqueda.status) {
        //     return false
        //   }
        //   return true
        // }}
        tipo={"idOrdenServicio"}
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        dataTable={dataTable}
        dataPdf={dataPdf}
        buscador={
          [
            // <Grid
            //   sx={{
            //     order: "2",
            //     padding: "0 5px 0 5px",
            //     marginTop: "10px",
            //     "@media (min-width: 900px)": {
            //       marginTop: "0px",
            //       marginBottom: "10px",
            //       order: "0"
            //     }
            //   }}
            //   item
            //   xs={12}
            //   key={1}
            // >
            //   <Input
            //     typeInput={"formSelect"}
            //     valor={busqueda?.status}
            //     nombre="Status de la orden de servicio"
            //     onChange={(e) =>
            //       setBusqueda({ ...busqueda, status: e.target.value })
            //     }
            //     data={[
            //       { label: "Todas", value: "" },
            //       { label: "PENDIENTE", value: "PENDIENTE" },
            //       { label: "DIAGNOSTICO", value: "DIAGNOSTICO" },
            //       { label: "COTIZADO", value: "COTIZADO" },
            //       { label: "PROCESO", value: "PROCESO" },
            //       { label: "CERRADO", value: "CERRADO" },
            //       { label: "FACTURADO", value: "FACTURADO" },
            //       { label: "CANCELADO", value: "CANCELADO" },
            //       { label: "FACT./CANCELADA", value: "FACT./CANCELADA" }
            //     ]}
            //   />
            // </Grid>
          ]
        }
        expand={"empresas,creados"}
        permisoCheck={"ordenServicios"}
        nombreBusqueda={"status"}
            />
          </section>
        </div>
      </main>
    </Vista>
  )
}
export default OrdenServicio
